import { Modal, Button, Row, Col } from "react-bootstrap";

import { useEffect, useRef, useState } from "react";

import moment from "moment";
import {
  PICKLIST_GROUP_NAME,
  QME_APPOINTMENT_STATUS,
  WEB_ROLE,
} from "../../../../common/Constant";
import MultilineTextBox from "../../../../common/MultilineTextBox";

import Snackbar from "../../../../common/Snackbar";

import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import { fetchPickListByGroupName } from "../../../../services/CaseInformationApi";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import TimePicker from "../../../../common/TimePicker";
import { UpdateScheduleDateByHistorian } from "../../../../services/HistorianAPI";
import { formatDateTime } from "../../../../utils/dateUtils";

interface AppointmentActionProps {
  show?: boolean;
  onHide?: (fromSave?: boolean) => void;
  selectedRowData?: any;
}

const HistorianScheduleDate = ({
  show,
  onHide,
  selectedRowData,
}: AppointmentActionProps) => {
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);

  const currentTime = moment(new Date()).format("HH:mm");

  const datePickerRef = useRef<HTMLDivElement>(null);
  const [scheduleDate, setScheduleDate] = useState<Date | null>(new Date());
  const [mediacreLocation, setMedicareLocation] = useState("");
  const [startTime, setStartTime] = useState<any>(currentTime);
  const [reasonForAction, setReasonForAction] = useState<string>("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");

  const [isSaving, setIsSaving] = useState(false);

  // multiple rows

  const handleStartTimeChange = (time: string) => {
    setStartTime(time);
  };
  const onSave = async () => {
    if (isSaving) return;
    try {
      setIsSaving(true);
      if (!startTime) {
        setSnackbarMessage("Please select a time.");
        setError("error");
        setSnackbarOpen(true);
        return;
      }

      if (!scheduleDate) {
        setSnackbarMessage("Please select a schedule date.");
        setError("error");
        setSnackbarOpen(true);
        return;
      }

      // 🧮 Parse the due date from selectedRowData (string to Date)
      const dueDate = selectedRowData?.dueDate
        ? new Date(selectedRowData.dueDate)
        : null;

      const getDateOnly = (date: Date) => {
        return new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
        ).getTime();
      };

      if (dueDate && getDateOnly(scheduleDate) > getDateOnly(dueDate)) {
        setSnackbarMessage("Please select a date on or before the due date.");
        setError("error");
        setSnackbarOpen(true);
        return;
      }

      const normalizeTime = (time: string | number | null): string => {
        if (time == null) return "";
        const timeStr = time.toString().trim();
        if (/^\d{1,2}$/.test(timeStr)) {
          return timeStr.padStart(2, "0") + ":00";
        }
        return timeStr;
      };

      // Normalize Times
      const normalizedStartTime = normalizeTime(startTime);

      const selectedDate = new Date(scheduleDate);
      const today = new Date();

      if (selectedDate.toDateString() === today.toDateString()) {
        const currentTime =
          today.getHours().toString().padStart(2, "0") +
          ":" +
          today.getMinutes().toString().padStart(2, "0");

        const now = new Date(`2000-01-01T${currentTime}`).getTime();
        const start = new Date(`2000-01-01T${normalizedStartTime}`).getTime();

        if (start < now) {
          setSnackbarMessage("Start Time cannot be less than current time");
          setError("error");
          setSnackbarOpen(true);
          return;
        }
      }

      const requestpayload = {
        subjectQMEScheduleId: selectedRowData.subjectQmeScheduleID,
        historianAssignedUserId: loggedInUserid,
        historianScheduleDate:
          scheduleDate && startTime
            ? formatDateTime(scheduleDate, startTime)
            : null,
        historianComments: reasonForAction,
      };

      const response = await UpdateScheduleDateByHistorian(requestpayload);

      if (response?.isSuccess) {
        setError("success");
        setSnackbarMessage("Call is scheduled for Patient");
        setSnackbarOpen(true);
        setScheduleDate(new Date());
        setStartTime("");
        setReasonForAction("");
      }
      onHide?.(true);
    } catch (error) {
      console.error("Error updating schedule date:", error);
    } finally {
      setIsSaving(false);
    }
  };

  const onCancel = () => {
    // do something before closing

    setScheduleDate(new Date());
    setStartTime("");
    setReasonForAction("");
    if (onHide) onHide();
  };

  return (
    <>
      <Snackbar
        message={snackbarMessage}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
      <Modal
        show={show}
        onHide={onCancel}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="recordList"
      >
        <Modal.Header closeButton className="d-flex">
          <Modal.Title className="fw-bold text-left modelheading offcanvas-title d-flex align-items-center">
            Schedule Date
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="fw-bold text-left modelheading ">
          <Row>
            <Col sm={5}>
              <FloatingLabelDatepicker
                ref={datePickerRef}
                label="Date"
                name="dateOfAppointment"
                value={scheduleDate}
                onChange={(date: Date | null) => {
                  setScheduleDate(date);
                  setStartTime("");
                }}
                required
                dateFormat="MM/dd/yyyy"
                minDate={new Date()}
              />
            </Col>
            <Col sm={5}>
              <TimePicker
                selectedTime={startTime}
                onChange={handleStartTimeChange}
                label="Time"
                required
                date={scheduleDate}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col sm={12}>
              <MultilineTextBox
                label="Comments"
                name="reason"
                value={reasonForAction ?? ""}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.startsWith(" ")) return;
                  value = value?.trimStart();
                  value = value.replace(/ {2,}/g, " ");
                  setReasonForAction(value);
                }}
                maxLength={100}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={onCancel}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={onSave}
            disabled={isSaving}
          >
            <span className="material-icons mx-1">save</span> Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default HistorianScheduleDate;
